<template>
    <div>
        <Dialog :show-close-button="true" :show="show"
                :has-backdrop="true" @close="$emit('close')" width="600px">
            <div class="share-dialog-container">
                <h3>Dashboard teilen</h3>
                <p>Jeder mit dem Link kann auf das Dashboard zugreifen.</p>
                <InputDetail label="Shareable Link" :value="link" icon="icon-clipboard"
                             icon-size="24px" @click="copyLink" icon-border></InputDetail>
                <Checkbox id="link-checkbox" :title="title" v-model="active"></Checkbox>
                <div style="margin-top: 20px;display: flex; flex-direction: row; align-items: center">
                    <AdaButton type="createButton" title="BESTÄTIGEN" @click="saveLink"></AdaButton>
                    <div style="margin-left: 20px">{{message}}</div>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
    import Dialog from "./Dialog";
    import InputDetail from "../inputs/InputDetail";
    import Checkbox from "../inputs/Checkbox";
    import AdaButton from "../buttons/AdaButton";

    export default {
        name: "ShareDialog",
        components: {
            Dialog,
            InputDetail,
            Checkbox,
            AdaButton
        },
        data: function () {
            return {
                active: false,
                message: ''
            }
        },
        props: {
            show: Boolean
        },
        computed: {
            link() {
                return location.href + '?key=' + this.$store.state.campaign.campaign.extern_link_hash;
            },
            title() {
                return this.active ? 'Der Link ist aktiv' : 'Der Link ist nicht aktiv';
            }
        },
        mounted() {
            this.active = this.$store.state.campaign.campaign.extern_link_is_active;
        },
        methods: {
            saveLink() {
                this.$store.dispatch('campaign/updateLinkState',
                    {
                        id: this.$route.params.id,
                        active: this.active
                    }
                ).then(() => {
                    this.$emit('close');
                }).catch(e => console.error(e));
            },
            copyLink() {
                this.$clipboard(this.link);
                this.message = 'Der Link wurde in die Zwischenablage kopiert.';
            }
        }
    }
</script>

<style lang="scss" scoped>

    .share-dialog-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .share-dialog-container > * {
        margin-bottom: 10px;
    }

    ::v-deep .checkbox-container {
        margin-left: 0;
    }

    ::v-deep .modal-container {
        display: flex;
        flex-flow: column;

        .title {
            margin-bottom: 20px;
        }
    }

</style>